import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraCouplesTherapySecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M29.6737 25.1102C32.0795 22.8303 34.4344 22.6002 36.4732 23.239C36.7925 20.3235 35.6589 17.4283 33.1714 16.0441C26.6726 12.4255 21.6172 19.3746 21.6172 19.3746C21.6172 19.3746 13.55 11.1681 8.15227 18.742C2.15157 27.1614 21.4507 40.4897 23.3106 40.07C24.5289 39.796 26.7759 37.8372 29.0861 35.288C27.3897 31.4611 26.9872 27.6562 29.6737 25.1117V25.1102Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M54.7373 27.3454C48.8014 22.208 42.7683 28.3585 42.7683 28.3585C42.7683 28.3585 40.1389 24.386 36.4731 23.2383C36.3559 24.3093 36.0474 25.3835 35.5292 26.3871C34.0965 29.1586 31.5565 32.5612 29.0859 35.2873C32.1148 42.1205 39.2907 49.0305 40.5121 48.9991C43.0922 48.9334 51.3584 42.6795 55.0936 37.957C57.6922 34.6719 57.6907 29.9024 54.7373 27.3454Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M36.4726 23.2379C34.4354 22.5991 32.0789 22.8308 29.6731 25.1091C26.9866 27.6551 27.3875 31.4585 29.0855 35.2853C31.5561 32.5592 34.0961 29.1567 35.5288 26.3852C36.047 25.3831 36.3554 24.3089 36.4726 23.2364V23.2379Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
